/**
 * Extern loket (UI-kant). De rol `callcenter` is een externe partij
 * (BizziPhone-antwoordservice) met één gedeeld account en ziet alleen:
 * nieuwe aanvraag (offerte of direct inboeken), prijzen, kennisbank lezen.
 *
 * Deze lijst stuurt het menu (navigation.ts) én de router-redirect
 * (AppLayout): elke andere URL, ook een ingetypte, komt op het loket uit.
 * De API-kant staat in `api/_lib/extern-loket.ts` (Edge Middleware) en RLS
 * in migratie 213. Runbook: docs/extern-loket.md.
 */
import type { Role } from '../components/layout/navigation';

export const EXTERN_LOKET_ROL: Role = 'callcenter';

export const EXTERN_LOKET_HOME = '/nieuwe-aanvraag';

/** Padprefixen die het extern loket mag openen. */
export const EXTERN_LOKET_PATHS: readonly string[] = ['/nieuwe-aanvraag', '/prijzen', '/kennis'];

export function isExternLoketPath(pathname: string): boolean {
  return EXTERN_LOKET_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

export function isExternLoket(role: Role | null): boolean {
  return role === EXTERN_LOKET_ROL;
}
